import { View } from '@react-pdf/renderer';
import React from 'react';
import DocumentPanelHeader from '../DocumentPanelHeader';
import DocumentPanelPaciente from '../DocumentPanelPaciente';

interface Props {
  title: string;
  photo?: string;
  encounter: fhir4.Encounter;
}

const DocumentHeadingDefault: React.FC<Props> = ({
  title,
  photo,
  encounter,
}) => {
  return (
    <View style={{ flexDirection: 'column', rowGap: 8 }}>
      <DocumentPanelHeader title={title} photo={photo} encounter={encounter} />
      <DocumentPanelPaciente encounter={encounter} />
    </View>
  );
};

export default DocumentHeadingDefault;
